module.exports = __webpack_public_path__ + "static/media/she_is_proactive_sign.7a325229.png";